import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import PaymentDetailsTable from '../tables/PaymentDetailsTable'
import { formatDate } from '../../utils'

const PaymentDetailsModal = ({
  show,
  onClose,
  selectedDate,
  title,
  dialogClassName = 'modal-lg mw-75',
}: any) => {
 
  return (
    <ConfirmationModal
      show={show}
      onClose={onClose}
      title={title || `Payment Schedule on ${formatDate(selectedDate)}`}
      body={
        <PaymentDetailsTable
        />
      }
      bodyClass='mh-650px overflow-auto p-5'
      disableFooter={true}
      dialogClassName={dialogClassName}
    />
  )
}

export default PaymentDetailsModal
